/**
 * @generated SignedSource<<d5583d29b443a7f9b1d3895c30349f7d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type SearchCombinationType = "AND" | "OR" | "%future added value";
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchParticipantType = "COMMENTED" | "CONTRIBUTOR" | "MENTIONS" | "PRESENCE" | "SHARED" | "VIEWED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchResults_AtlassianSearchPage$data = {
  readonly search: {
    readonly search: {
      readonly autoAppliedFilters?: {
        readonly commonFilters: {
          readonly participants: {
            readonly combination: SearchCombinationType;
            readonly items: ReadonlyArray<{
              readonly combination: SearchCombinationType;
              readonly type: SearchParticipantType;
              readonly users: ReadonlyArray<string>;
            }> | null | undefined;
          } | null | undefined;
          readonly range: {
            readonly lastModified: {
              readonly gt: string | null | undefined;
              readonly lt: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: string;
          readonly connectorId?: string | null | undefined;
          readonly connectorProduct?: string | null | undefined;
          readonly connectorType?: string | null | undefined;
          readonly description: string;
          readonly id: string;
          readonly integrationId?: string | null | undefined;
          readonly issue?: {
            readonly webUrl: AGG$URL | null | undefined;
          } | null | undefined;
          readonly linkedResults: ReadonlyArray<{
            readonly category: SearchLinkedResultCategory;
            readonly connectorType: string | null | undefined;
            readonly id: string;
          }> | null | undefined;
          readonly ownerId?: string | null | undefined;
          readonly providerId?: string | null | undefined;
          readonly socialSignal?: {
            readonly signal: string | null | undefined;
          } | null | undefined;
          readonly url?: string;
          readonly " $fragmentSpreads": FragmentRefs<"searchResult_AtlassianSearchPage">;
        } | null | undefined;
      }>;
      readonly errors: ReadonlyArray<{
        readonly integration: string | null | undefined;
        readonly product: string | null | undefined;
        readonly statusCode: number;
      }> | null | undefined;
      readonly pageInfo: {
        readonly endCursor: string | null | undefined;
      };
      readonly queryInfo: {
        readonly originalQuery: string | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"autoCorrection_AtlassianSearchPage">;
      } | null | undefined;
      readonly totalCounts?: ReadonlyArray<{
        readonly count: number;
        readonly product: string;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "searchResults_AtlassianSearchPage";
};
export type searchResults_AtlassianSearchPage$key = {
  readonly " $data"?: searchResults_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResults_AtlassianSearchPage">;
};

import SearchResultsPaginationQuery_graphql from './SearchResultsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "search",
  "search"
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "connectorType"
},
v3 = {
  "kind": "ScalarField",
  "name": "combination"
},
v4 = {
  "kind": "ScalarField",
  "name": "product"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__isassetsenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "assetsFilters"
    },
    {
      "kind": "RootArgument",
      "name": "cloudIdARI"
    },
    {
      "kind": "RootArgument",
      "name": "commonFilters"
    },
    {
      "kind": "RootArgument",
      "name": "compassFilters"
    },
    {
      "kind": "RootArgument",
      "name": "confluenceFilters"
    },
    {
      "kind": "RootArgument",
      "name": "disableQueryReplacement"
    },
    {
      "kind": "RootArgument",
      "name": "enableHighlighting"
    },
    {
      "kind": "RootArgument",
      "name": "entities"
    },
    {
      "kind": "RootArgument",
      "name": "experience"
    },
    {
      "kind": "RootArgument",
      "name": "experimentId"
    },
    {
      "kind": "RootArgument",
      "name": "experimentLayers"
    },
    {
      "kind": "RootArgument",
      "name": "fanoutExperimentCohort"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAssigneeField"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAutoAppliedFilters"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeIconUrl"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeNavBoostScore"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePassionfruitAsk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePositions"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeThirdPartyId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeTotalCounts"
    },
    {
      "kind": "RootArgument",
      "name": "jiraFilters"
    },
    {
      "kind": "RootArgument",
      "name": "limit"
    },
    {
      "kind": "RootArgument",
      "name": "mercuryFilters"
    },
    {
      "kind": "RootArgument",
      "name": "query"
    },
    {
      "kind": "RootArgument",
      "name": "queryVersion"
    },
    {
      "kind": "RootArgument",
      "name": "searchSessionId"
    },
    {
      "kind": "RootArgument",
      "name": "sessionId"
    },
    {
      "kind": "RootArgument",
      "name": "shadowExperimentId"
    },
    {
      "kind": "RootArgument",
      "name": "sort"
    },
    {
      "kind": "RootArgument",
      "name": "sourceProduct"
    },
    {
      "kind": "RootArgument",
      "name": "talentFilters"
    },
    {
      "kind": "RootArgument",
      "name": "tenantId"
    },
    {
      "kind": "RootArgument",
      "name": "thirdPartyFilters"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "limit",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "limit",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": SearchResultsPaginationQuery_graphql
    }
  },
  "name": "searchResults_AtlassianSearchPage",
  "selections": [
    {
      "concreteType": "SearchQueryAPI",
      "kind": "LinkedField",
      "name": "search",
      "plural": false,
      "selections": [
        {
          "alias": "search",
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "queryVersion",
                  "variableName": "queryVersion"
                },
                {
                  "kind": "Variable",
                  "name": "searchSessionId",
                  "variableName": "searchSessionId"
                },
                {
                  "kind": "Variable",
                  "name": "sessionId",
                  "variableName": "sessionId"
                },
                {
                  "kind": "Variable",
                  "name": "sourceProduct",
                  "variableName": "sourceProduct"
                }
              ],
              "kind": "ObjectValue",
              "name": "analytics"
            },
            {
              "kind": "Variable",
              "name": "disableQueryReplacement",
              "variableName": "disableQueryReplacement"
            },
            {
              "kind": "Variable",
              "name": "enableHighlighting",
              "variableName": "enableHighlighting"
            },
            {
              "kind": "Variable",
              "name": "experience",
              "variableName": "experience"
            },
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "experimentId",
                  "variableName": "experimentId"
                },
                {
                  "kind": "Variable",
                  "name": "experimentLayers",
                  "variableName": "experimentLayers"
                },
                {
                  "kind": "Variable",
                  "name": "shadowExperimentId",
                  "variableName": "shadowExperimentId"
                }
              ],
              "kind": "ObjectValue",
              "name": "experimentContext"
            },
            {
              "kind": "Variable",
              "name": "fanoutExperimentCohort",
              "variableName": "fanoutExperimentCohort"
            },
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "assetsFilters",
                  "variableName": "assetsFilters"
                },
                {
                  "kind": "Variable",
                  "name": "commonFilters",
                  "variableName": "commonFilters"
                },
                {
                  "kind": "Variable",
                  "name": "compassFilters",
                  "variableName": "compassFilters"
                },
                {
                  "kind": "Variable",
                  "name": "confluenceFilters",
                  "variableName": "confluenceFilters"
                },
                {
                  "kind": "Variable",
                  "name": "entities",
                  "variableName": "entities"
                },
                {
                  "kind": "Variable",
                  "name": "jiraFilters",
                  "variableName": "jiraFilters"
                },
                {
                  "items": [
                    {
                      "kind": "Variable",
                      "name": "locations.0",
                      "variableName": "cloudIdARI"
                    }
                  ],
                  "kind": "ListValue",
                  "name": "locations"
                },
                {
                  "kind": "Variable",
                  "name": "mercuryFilters",
                  "variableName": "mercuryFilters"
                },
                {
                  "kind": "Variable",
                  "name": "talentFilters",
                  "variableName": "talentFilters"
                },
                {
                  "kind": "Variable",
                  "name": "thirdPartyFilters",
                  "variableName": "thirdPartyFilters"
                }
              ],
              "kind": "ObjectValue",
              "name": "filters"
            },
            {
              "kind": "Variable",
              "name": "query",
              "variableName": "query"
            },
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            }
          ],
          "concreteType": "SearchItemConnection",
          "kind": "LinkedField",
          "name": "__SearchResultsPagination__search_connection",
          "plural": false,
          "selections": [
            {
              "concreteType": "SearchResultItemEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    },
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "description"
                    },
                    {
                      "concreteType": "SearchLinkedResult",
                      "kind": "LinkedField",
                      "name": "linkedResults",
                      "plural": true,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "category"
                        },
                        (v2/*: any*/)
                      ]
                    },
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "includeAssets",
                          "variableName": "__relay_internal__pv__isassetsenabledrelayprovider"
                        },
                        {
                          "kind": "Variable",
                          "name": "includeAssigneeField",
                          "variableName": "includeAssigneeField"
                        },
                        {
                          "kind": "Variable",
                          "name": "includeIconUrl",
                          "variableName": "includeIconUrl"
                        },
                        {
                          "kind": "Variable",
                          "name": "includeNavBoostScore",
                          "variableName": "includeNavBoostScore"
                        },
                        {
                          "kind": "Variable",
                          "name": "includePassionfruitAsk",
                          "variableName": "includePassionfruitAsk"
                        },
                        {
                          "kind": "Variable",
                          "name": "includePositions",
                          "variableName": "includePositions"
                        },
                        {
                          "kind": "Variable",
                          "name": "includeThirdPartyId",
                          "variableName": "includeThirdPartyId"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "searchResult_AtlassianSearchPage"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "providerId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "integrationId"
                        },
                        (v2/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "connectorId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "connectorProduct"
                        }
                      ],
                      "type": "SearchResultGraphDocument"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "ownerId"
                        }
                      ],
                      "type": "SearchResultCompassComponent"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "url"
                        },
                        {
                          "concreteType": "JiraIssue",
                          "kind": "LinkedField",
                          "name": "issue",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "webUrl"
                            }
                          ]
                        }
                      ],
                      "type": "SearchResultJiraIssue"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "tenantId",
                              "variableName": "tenantId"
                            }
                          ],
                          "concreteType": "SocialSignalSearch",
                          "kind": "LinkedField",
                          "name": "socialSignal",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "signal"
                            }
                          ]
                        }
                      ],
                      "type": "SearchConfluencePageBlogAttachment"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "cursor"
                }
              ]
            },
            {
              "concreteType": "SearchQueryInfo",
              "kind": "LinkedField",
              "name": "queryInfo",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "originalQuery"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "autoCorrection_AtlassianSearchPage"
                }
              ]
            },
            {
              "condition": "includeAutoAppliedFilters",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "SearchFilterOutput",
                  "kind": "LinkedField",
                  "name": "autoAppliedFilters",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "SearchCommonFilterOutput",
                      "kind": "LinkedField",
                      "name": "commonFilters",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "SearchCommonRangeFilterOutput",
                          "kind": "LinkedField",
                          "name": "range",
                          "plural": false,
                          "selections": [
                            {
                              "concreteType": "SearchCommonRangeFilterFieldsOutput",
                              "kind": "LinkedField",
                              "name": "lastModified",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "gt"
                                },
                                {
                                  "kind": "ScalarField",
                                  "name": "lt"
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "concreteType": "SearchParticipantsOutput",
                          "kind": "LinkedField",
                          "name": "participants",
                          "plural": false,
                          "selections": [
                            {
                              "concreteType": "SearchParticipantOutput",
                              "kind": "LinkedField",
                              "name": "items",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "type"
                                },
                                {
                                  "kind": "ScalarField",
                                  "name": "users"
                                },
                                (v3/*: any*/)
                              ]
                            },
                            (v3/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "endCursor"
                },
                {
                  "kind": "ScalarField",
                  "name": "hasNextPage"
                }
              ]
            },
            {
              "concreteType": "SearchError",
              "kind": "LinkedField",
              "name": "errors",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "statusCode"
                },
                (v4/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "integration"
                }
              ]
            },
            {
              "condition": "includeTotalCounts",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "SearchProductCount",
                  "kind": "LinkedField",
                  "name": "totalCounts",
                  "plural": true,
                  "selections": [
                    (v4/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "count"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "c985222b9af0ccd534257e231bac61ee";

export default node;
